class NextStepNotFound extends Error {}

export default NextStepNotFound;
